import {StyleDeclaration} from 'aphrodite';

import {GRAY_DARKER} from 'ui-library/Colors';

export const LOOKUP_CHIP: StyleDeclaration = {
  marginRight: '0px',
  verticalAlign: 'middle',
  cursor: 'pointer',
};

export const ADDITIONAL_LOOKUP_CHIP_DESCRIPTION: StyleDeclaration = {
  display: 'inline-block',
  color: GRAY_DARKER,
  marginLeft: '7px',
  verticalAlign: 'middle',
};
